<script>
  import {
    VCardTitle
  } from 'vuetify/lib'
  export default {
    name: 'wh-card-title',
    extends: VCardTitle
  };
</script>